import { Select } from 'antd';
import { useCallback, useEffect, useState, type FC } from 'react';

import { useLazyGetClientServicesQuery } from '@app/api/ClientServices';
import { useUserPrint } from '@app/hooks';
import '@app/components/ClientServicesSelect/styles/ClientServicesSelect.desktop.scss';

import type { BaseOptionType } from 'antd/es/select';

const allRecordsOption = {
  value: -1,
  label: 'Все записи',
};

type Props = {
  value: number[];
  onChange: (values: number[]) => void;
};

export const ClientServicesSelect: FC<Props> = ({ value, onChange }) => {
  const { activeBranchId } = useUserPrint();
  const [services, setServices] = useState<BaseOptionType[]>([]);
  const [getClientServices] = useLazyGetClientServicesQuery();

  useEffect(() => {
    const getServices = async () => {
      const data = await getClientServices({
        ActiveBranchId: activeBranchId,
      }).unwrap();
      const options = data.map(({ Id, Name }) => ({ label: Name, value: Id }));
      options.push(allRecordsOption);
      setServices(options);
      if (!value || value.length === 0) {
        onChange([allRecordsOption.value]);
      }
    };
    getServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeOptionsHandler = useCallback(
    (value: number[]) => {
      if (value.length === services.length || value.length === 0) {
        onChange([allRecordsOption.value]);
        return;
      }

      if (value.length > 1 && value.length < services.length) {
        onChange([...value.filter((value: number) => value !== -1)]);
        return;
      }

      onChange(value);
    },
    [onChange, services.length]
  );

  return (
    <Select
      className="client-services-container"
      mode="multiple"
      size="small"
      placeholder="Все услуги"
      options={services}
      value={value}
      onChange={changeOptionsHandler}
    />
  );
};
